import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Title from '../../components/Header/parts/Title';

import StaffCard from '../../components/Card/Staff';

const StaffList = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
`;
const StaffItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
  flex-basis: 33.3%;
  max-width: 400px;

  padding: 2.4rem;
  flex-grow: 1;
  flex-shrink: 0;
`;

const HeroLogos = ({ input }) => {
  const members = input.items.map(({ member }, index) => {
    const profile = member.document.data;

    return (
      <StaffItem key={index + profile.name}>
        <StaffCard page={null} {...profile} />
      </StaffItem>
    );
  });

  return (
    <>
      <Title
        title={input.primary.title.html}
        subtitle={input.primary.subtitle.html}
        description={input.primary.description.html}
        title_align={input.primary.align_text}
      />
      <StaffList>{members}</StaffList>
    </>
  );
};

HeroLogos.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HeroLogos;
